import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./style/sidefilter.css";


const SideFilter = ({ filter, selectedFilters, setSelectedFilters }) => {

  const [open, setOpen] = useState(null);

  const handleOpen = (value) => {
    setOpen(open === value ? null : value);
  };

  const handleSetFilters = (filterType, filterValue) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: filterValue,
    }));
  };

  const handleCheckboxChange = (filterType, value) => {
    const filterData = { ...selectedFilters };
    const currentFilter = filterData[filterType] || [];
    const index = currentFilter?.indexOf(value);
    if (index !== -1) {
      currentFilter.splice(index, 1);
    } else {
      currentFilter.push(value);
    }
    handleSetFilters(filterType, currentFilter);
  };

  return (
      <div style={{ marginTop: "35px", marginLeft: "10px" }} className="side-filter-main">
        <Accordion
          expanded={open === 1}
          onChange={() => handleOpen(1)}
          sx={{ boxShadow: "none" ,width: "350px"}}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="text-black tracking-wider text-lg"
          >
            Category
          </AccordionSummary>
          <AccordionDetails>
            {filter?.Categories?.map((category, index) => (
              <ul key={index} className="flex justify-between items-center">
                <li className="p-1 text-base cursor-pointer">{category}</li>
                <label className="container1">
                  <input
                    type="checkbox"
                    onChange={() => handleSetFilters("category", [category])}
                    checked={selectedFilters?.category?.includes(category)}
                  />
                  <span className="checkmark"></span>
                </label>
              </ul>
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={open === 2}
          onChange={() => handleOpen(2)}
          sx={{ boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            className="text-gray-800"
          >
            Jewellery Color
          </AccordionSummary>
          <AccordionDetails>
            {filter?.ColorData?.map((jewelryColor, index) => (
              <ul key={index} className="flex justify-between items-center">
                <li className="p-1 text-base">{jewelryColor}</li>
                <label className="container1">
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange("jewelryColor", jewelryColor)
                    }
                    checked={selectedFilters?.jewelryColor?.includes(
                      jewelryColor
                    )}
                  />
                  <span className="checkmark"></span>
                </label>
              </ul>
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={open === 3}
          onChange={() => handleOpen(3)}
          sx={{ boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
            className="text-gray-800"
          >
            Jewellery Material
          </AccordionSummary>
          <AccordionDetails>
            {filter?.MaterialData?.map((jewelryMaterial, index) => (
              <ul key={index} className="flex justify-between items-center">
                <li className="p-1 text-base">{jewelryMaterial}</li>
                <label className="container1">
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange("jewelryMaterial", jewelryMaterial)
                    }
                    checked={selectedFilters?.jewelryMaterial?.includes(
                      jewelryMaterial
                    )}
                  />
                  <span className="checkmark"></span>
                </label>
              </ul>
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={open === 4}
          onChange={() => handleOpen(4)}
          sx={{ boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5a-content"
            id="panel5a-header"
            className="text-gray-800"
          >
            Diamond Type
          </AccordionSummary>
          <AccordionDetails>
            {filter?.diamontData?.map((diamondType, index) => (
              <ul key={index} className="flex justify-between items-center">
                <li className="p-1 text-base">{diamondType}</li>
                <label className="container1">
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange("diamondType", diamondType)
                    }
                    checked={selectedFilters?.diamondType?.includes(
                      diamondType
                    )}
                  />
                  <span className="checkmark"></span>
                </label>
              </ul>
            ))}
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={open === 5}
          onChange={() => handleOpen(5)}
          sx={{ boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel6a-content"
            id="panel6a-header"
            className="text-gray-800"
          >
            Jewellery Carat
          </AccordionSummary>
          <AccordionDetails>
            {filter?.CaratsData?.map((jewelryCarat, index) => (
              <ul key={index} className="flex justify-between items-center">
                <li className="p-1 text-base">{jewelryCarat}</li>
                <label className="container1">
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleCheckboxChange("jewelryCarat", jewelryCarat)
                    }
                    checked={selectedFilters?.jewelryCarat?.includes(
                      jewelryCarat
                    )}
                  />
                  <span className="checkmark"></span>
                </label>
              </ul>
            ))}
          </AccordionDetails>
        </Accordion>
      </div>

  );
};

export default SideFilter;
